
import {  map, mergeMap, tap } from 'rxjs/operators';
import {  Injectable } from '@angular/core';
import {  Observable} from 'rxjs';
import { MediaServiceApi } from '../../../api/mediaService/media-service.api';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { MessageService } from 'primeng/api';
import { MediaApi, MediaSummaryApi } from '../../../api/contentLibrary/models/content-library-media.api.model';
import { MediaModel } from '../models/content-library-media.model';
import { MediaSummaryModel } from '../models/content-library-media-summary.model';
import { AllResourceAbstractService } from '../../Basic/service/all-resource-abstract.service';
import { MultiBaseAbstractApi } from '../../../api/genericApi/multi-base-abstract.api';
import { ResourceAction } from '../../../Common/Basic/service/resource-abstract.service';
import { ContentLibraryApi } from '../../../api/contentLibrary/contentLibrary.api';
import { UserNoteModel } from '../../Misc/models/user-note.model';

@Injectable()
export class ContentLibraryMediaService extends AllResourceAbstractService<MediaModel, MediaApi, MediaSummaryModel, MediaSummaryApi> {

    constructor(
        protected localizationService: LocalizationService,
        protected mediaServiceApi: MediaServiceApi,
        protected messageService: MessageService,
        protected contentLibraryApi: ContentLibraryApi,

    ) {
        super();
    }
    getApiService(): MultiBaseAbstractApi<MediaApi, MediaSummaryApi> {
        return this.mediaServiceApi;
    }
    constructListModel(listApiModel: MediaSummaryApi): MediaSummaryModel {
        return new MediaSummaryModel(listApiModel);
    }
    constructResourceModel(apiModel: MediaApi): MediaModel {
        return new MediaModel(apiModel);
    }
    messageCenter(actionResult: ResourceAction): void {
        return;
    }

    createNote(note: UserNoteModel, contentId: string): Observable<number> {
        return this.mediaServiceApi.createNote(contentId, note.toMediaNoteApiModel());
    }

    approveMedia(contentId: string): Observable<MediaModel> {
        return this.mediaServiceApi.approveMedia(contentId).pipe(
            mergeMap(() => this.getMediaModel(contentId)),
            tap(() => this.refreshAll())
        );
    }

    updateNote(note: UserNoteModel, contentId: string): Observable<number> {
        return this.mediaServiceApi.updateNote(contentId, note.id, note.toMediaNoteApiModel());
    }

    deleteNote(contentId: string, noteId: number): Observable<number> {
        return this.mediaServiceApi.deleteNote(contentId, noteId);
    }

    getMediaModel(contentId: string): Observable<MediaModel> {
        return this.mediaServiceApi.getMedia(contentId).pipe(
            map((mediaApiModel: MediaApi) => new MediaModel(mediaApiModel))
        );
    }

    updateMediaName(contentId: string, media: MediaModel): Observable<number> {
        return this.contentLibraryApi.updateMediaContent(contentId, media.toApiModel());
    }

    getMediaItemsByFolderId(folderId: number): Observable<MediaSummaryModel[]> {
        return this.all$.pipe(
            map(items => items.filter(item =>
                item.libraryIds?.includes(folderId)
            ))
        );
    }
}
